export const phoneMask = '+{7} (000) 000-00-00'
export const passportMask = '00 00 000000'
export const snilsMask = '000-000-000 00'
export const onlyNumberMask = Number
